/* CATALOG SHEET — Template 3 preview (table-first, B2B utility).
 * Sample brand: Industrial Hardware. Slate + Safety Orange. Light mode. */
import { useCatalogFonts } from "./_fonts";
import { PreviewRibbon } from "./LinesheetPreview";
import {
  Search, ShoppingCart, Upload, Download, Filter, Zap,
  ChevronDown, ArrowUpDown, Plus, Minus, ChevronRight, Hash,
} from "lucide-react";

const IMG_1 = "https://images.unsplash.com/photo-1606337321936-02d1b1a4d5ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWV0YWwlMjBoYXJkd2FyZXxlbnwwfHx8fDE3ODE4MTg5NTV8MA&ixlib=rb-4.1.0&q=85";
const IMG_2 = "https://images.unsplash.com/photo-1515707384144-8c119444db05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwbWV0YWwlMjBoYXJkd2FyZXxlbnwwfHx8fDE3ODE4MTg5NTV8MA&ixlib=rb-4.1.0&q=85";
const IMG_3 = "https://images.unsplash.com/photo-1776361460587-e5f9396ebf88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwbWV0YWwlMjBoYXJkd2FyZXxlbnwwfHx8fDE3ODE4MTg5NTV8MA&ixlib=rb-4.1.0&q=85";

const COLORS = {
  bg:       "#F1F5F9",
  surface:  "#FFFFFF",
  primary:  "#FF5A1F",
  text:     "#0F172A",
  muted:    "#64748B",
  border:   "#E2E8F0",
  hover:    "#F8FAFC",
};

const ROWS = [
  { sku: "HX-M8-25",       img: IMG_1, name: "M8 × 25mm Hex Bolt, A2 SS",        cat: "Fasteners", price: 0.42,  tier: "1000+ @ $0.36", moq: 100, stock: 12400, qty: 100 },
  { sku: "HX-M8-30",       img: IMG_2, name: "M8 × 30mm Hex Bolt, A2 SS",        cat: "Fasteners", price: 0.48,  tier: "1000+ @ $0.41", moq: 100, stock: 8200,  qty: 100 },
  { sku: "FL-M10",         img: IMG_3, name: "M10 Stainless Flange Nut",         cat: "Fasteners", price: 0.18,  tier: "5000+ @ $0.14", moq: 250, stock: 26000, qty: 250 },
  { sku: "WS-DIN125-M8",   img: IMG_1, name: "DIN125 Washer M8, Zinc-plated",    cat: "Washers",   price: 0.06,  tier: null,            moq: 500, stock: 60000, qty: 500 },
  { sku: "SPR-LCK-M8",     img: IMG_2, name: "Lock Washer M8, Phosphate",        cat: "Washers",   price: 0.09,  tier: "2000+ @ $0.07", moq: 500, stock: 18000, qty: 500 },
  { sku: "AL-EXT-2020",    img: IMG_3, name: "Aluminum Extrusion 20×20, 1m",     cat: "Profiles",  price: 4.80,  tier: "50+ @ $4.20",   moq: 10,  stock: 480,   qty: 10 },
  { sku: "AL-EXT-4040",    img: IMG_1, name: "Aluminum Extrusion 40×40, 1m",     cat: "Profiles",  price: 12.40, tier: "50+ @ $10.80",  moq: 4,   stock: 120,   qty: 4 },
  { sku: "BRG-608ZZ",      img: IMG_2, name: "608ZZ Sealed Ball Bearing",        cat: "Bearings",  price: 0.84,  tier: "200+ @ $0.72",  moq: 50,  stock: 3200,  qty: 50 },
  { sku: "BRG-LM8UU",      img: IMG_3, name: "LM8UU Linear Bearing",             cat: "Bearings",  price: 1.62,  tier: "200+ @ $1.40",  moq: 25,  stock: 0,     qty: 25 },
  { sku: "ROD-LIN-8-300",  img: IMG_1, name: "Linear Shaft 8mm × 300mm Hardened",cat: "Shafts",    price: 6.20,  tier: null,            moq: 20,  stock: 880,   qty: 20 },
  { sku: "CPL-5-8",        img: IMG_2, name: "Flexible Coupling 5mm → 8mm",      cat: "Couplings", price: 2.40,  tier: "200+ @ $2.00",  moq: 25,  stock: 640,   qty: 25 },
  { sku: "SCR-BTN-M3-8",   img: IMG_3, name: "M3 × 8mm Button Head Cap Screw",   cat: "Fasteners", price: 0.05,  tier: "5000+ @ $0.04", moq: 1000,stock: 84000, qty: 1000 },
];

const BESTSELLERS = [
  { sku: "HX-M8-25", name: "M8 × 25mm Hex Bolt",   price: 0.42, img: IMG_1 },
  { sku: "FL-M10",   name: "M10 Flange Nut",       price: 0.18, img: IMG_2 },
  { sku: "BRG-608ZZ",name: "608ZZ Bearing",         price: 0.84, img: IMG_3 },
  { sku: "AL-EXT-2020", name: "AL Extrusion 20×20", price: 4.80, img: IMG_1 },
];

export default function CatalogSheetPreview() {
  useCatalogFonts();
  return (
    <div style={{ background: COLORS.bg, color: COLORS.text, fontFamily: "'Chivo', sans-serif", minHeight: "100vh" }} data-testid="catalog-sheet-preview">
      <PreviewRibbon name="Catalog Sheet"/>

      {/* Compact brand bar */}
      <div className="sticky top-9 z-20 px-6 py-3 flex items-center justify-between" style={{ background: COLORS.surface, borderBottom: `1px solid ${COLORS.border}` }}>
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 grid place-items-center rounded-md" style={{ background: COLORS.text, color: COLORS.primary, fontFamily: "'Chivo', sans-serif", fontWeight: 800 }}>
            FX
          </span>
          <div>
            <div className="text-[9.5px] uppercase tracking-[0.24em]" style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>Supplier · est. 1987</div>
            <div className="text-[13.5px] font-semibold">Forge &amp; Fix Industrial Supply</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button className="h-9 px-3 rounded-md text-xs inline-flex items-center gap-1.5" style={{ border: `1px solid ${COLORS.border}` }}>
            <Upload className="w-3.5 h-3.5"/>Import
          </button>
          <button className="h-9 px-3 rounded-md text-xs inline-flex items-center gap-1.5" style={{ border: `1px solid ${COLORS.border}` }}>
            <Download className="w-3.5 h-3.5"/>Export CSV
          </button>
          <button className="h-9 px-4 rounded-md text-xs font-semibold inline-flex items-center gap-1.5" style={{ background: COLORS.primary, color: "#fff" }} data-testid="cart-btn">
            <ShoppingCart className="w-3.5 h-3.5"/>Cart · 8
          </button>
        </div>
      </div>

      {/* Page heading + search */}
      <div className="px-6 pt-6 pb-4">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em]" style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>Apps · Catalog</div>
            <h1 className="mt-1.5" style={{ fontSize: 34, fontWeight: 800, letterSpacing: "-0.015em" }}>Order sheet</h1>
            <div className="text-[12.5px] mt-1" style={{ color: COLORS.muted }}>
              <span style={{ fontFamily: "'Roboto Mono', monospace" }}>{ROWS.length}</span> SKUs in stock ·
              Updated <span style={{ fontFamily: "'Roboto Mono', monospace" }}>2026-02-18 09:14</span>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-1 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: COLORS.muted }}/>
              <input
                placeholder="Search SKU, name, UPC, category…"
                className="w-full h-10 rounded-md pl-9 pr-3 text-sm focus:outline-none"
                style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}
              />
            </div>
            <button className="h-10 px-3 rounded-md text-xs inline-flex items-center gap-1.5" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
              <Filter className="w-3.5 h-3.5"/>Filters · 0
            </button>
            <button className="h-10 px-3 rounded-md text-xs inline-flex items-center gap-1.5" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
              Sort <ChevronDown className="w-3 h-3"/>
            </button>
          </div>
        </div>
      </div>

      <div className="px-6 pb-12 grid lg:grid-cols-[1fr_320px] gap-5">
        <div>
          {/* Bestsellers strip */}
          <div className="mb-5">
            <div className="text-[10px] uppercase tracking-[0.22em] mb-2.5" style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>Bestsellers · 30d</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {BESTSELLERS.map((b) => (
                <div key={b.sku} className="rounded-lg p-3 flex items-center gap-3" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
                  <img src={b.img} alt="" className="w-12 h-12 rounded object-cover"/>
                  <div className="min-w-0 flex-1">
                    <div className="text-[10px]" style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>{b.sku}</div>
                    <div className="text-xs font-medium truncate">{b.name}</div>
                    <div className="text-xs mt-0.5" style={{ color: COLORS.primary, fontWeight: 700, fontFamily: "'Roboto Mono', monospace" }}>${b.price.toFixed(2)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* DATA TABLE */}
          <div className="rounded-lg overflow-hidden" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
            <table className="w-full text-[12.5px]">
              <thead>
                <tr style={{ background: COLORS.hover, borderBottom: `1px solid ${COLORS.border}` }}>
                  <Th w="40"><input type="checkbox"/></Th>
                  <Th w="56"></Th>
                  <Th w="120"><span className="inline-flex items-center gap-1">SKU <ArrowUpDown className="w-3 h-3 opacity-50"/></span></Th>
                  <Th>Name</Th>
                  <Th w="110">Category</Th>
                  <Th w="140" right><span className="inline-flex items-center gap-1">Price <ArrowUpDown className="w-3 h-3 opacity-50"/></span></Th>
                  <Th w="80"  right>MOQ</Th>
                  <Th w="110" right>Stock</Th>
                  <Th w="180" right>Qty</Th>
                  <Th w="100"></Th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, i) => (
                  <tr key={r.sku} style={{ borderBottom: i === ROWS.length - 1 ? "none" : `1px solid ${COLORS.border}` }} className="hover:bg-slate-50">
                    <Td><input type="checkbox"/></Td>
                    <Td><img src={r.img} alt="" className="w-12 h-12 rounded object-cover"/></Td>
                    <Td><span style={{ fontFamily: "'Roboto Mono', monospace", fontWeight: 600 }}>{r.sku}</span></Td>
                    <Td>
                      <div className="font-medium">{r.name}</div>
                      {r.tier && <div className="text-[10.5px] mt-0.5" style={{ color: COLORS.primary, fontFamily: "'Roboto Mono', monospace" }}>{r.tier}</div>}
                    </Td>
                    <Td>
                      <span className="text-[10.5px] uppercase px-2 py-0.5 rounded" style={{ background: COLORS.hover, color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>{r.cat}</span>
                    </Td>
                    <Td right>
                      <div style={{ fontFamily: "'Roboto Mono', monospace", fontWeight: 700 }}>${r.price.toFixed(2)}</div>
                      <div className="text-[10px]" style={{ color: COLORS.muted }}>/ unit</div>
                    </Td>
                    <Td right><span style={{ fontFamily: "'Roboto Mono', monospace" }}>{r.moq.toLocaleString()}</span></Td>
                    <Td right>
                      <span style={{ fontFamily: "'Roboto Mono', monospace", color: r.stock === 0 ? "#DC2626" : r.stock < 1000 ? "#CA8A04" : COLORS.text }}>
                        {r.stock.toLocaleString()}
                      </span>
                    </Td>
                    <Td right>
                      <div className="inline-flex items-center rounded-md overflow-hidden" style={{ border: `1px solid ${COLORS.border}` }}>
                        <button className="w-7 h-8 grid place-items-center hover:bg-slate-100" style={{ color: COLORS.muted }}><Minus className="w-3 h-3"/></button>
                        <input value={r.qty.toLocaleString()} readOnly className="w-16 h-8 text-center text-xs focus:outline-none" style={{ fontFamily: "'Roboto Mono', monospace", background: "transparent" }}/>
                        <button className="w-7 h-8 grid place-items-center hover:bg-slate-100" style={{ color: COLORS.muted }}><Plus className="w-3 h-3"/></button>
                      </div>
                    </Td>
                    <Td right>
                      <button
                        disabled={r.stock === 0}
                        className="h-8 px-3 rounded-md text-[11px] font-semibold inline-flex items-center gap-1"
                        style={{ background: r.stock === 0 ? COLORS.border : COLORS.primary, color: r.stock === 0 ? COLORS.muted : "#fff" }}
                      >
                        <Plus className="w-3 h-3"/>Add
                      </button>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 flex items-center justify-between text-[11.5px]" style={{ color: COLORS.muted }}>
            <div>Showing <span style={{ color: COLORS.text, fontWeight: 600, fontFamily: "'Roboto Mono', monospace" }}>{ROWS.length}</span> of 412 SKUs</div>
            <div className="inline-flex items-center gap-1">
              <button className="px-2 py-1 rounded" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>‹</button>
              <button className="px-2.5 py-1 rounded text-white" style={{ background: COLORS.text }}>1</button>
              <button className="px-2.5 py-1 rounded" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>2</button>
              <button className="px-2.5 py-1 rounded" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>3</button>
              <span className="px-1">…</span>
              <button className="px-2.5 py-1 rounded" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>35</button>
              <button className="px-2 py-1 rounded" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>›</button>
            </div>
          </div>
        </div>

        {/* QUICK ORDER ASIDE */}
        <aside className="space-y-4">
          <div className="rounded-lg p-5" style={{ background: COLORS.text, color: "#fff" }}>
            <div className="flex items-center gap-2">
              <span className="w-7 h-7 grid place-items-center rounded" style={{ background: COLORS.primary }}>
                <Zap className="w-3.5 h-3.5"/>
              </span>
              <div className="text-[10.5px] uppercase tracking-[0.22em] opacity-75" style={{ fontFamily: "'Roboto Mono', monospace" }}>Quick order</div>
            </div>
            <h3 className="mt-3 text-lg font-semibold leading-tight">Paste your order. Tab to fly.</h3>
            <p className="mt-1.5 text-[11.5px] opacity-70 leading-relaxed">
              One SKU per line: <span style={{ fontFamily: "'Roboto Mono', monospace" }}>SKU,qty</span>.
              We&apos;ll match, validate MOQ, and stage everything in your cart.
            </p>
            <textarea
              rows={8}
              defaultValue={"HX-M8-25,500\nFL-M10,1000\nBRG-608ZZ,200\nAL-EXT-4040,12"}
              className="mt-3 w-full rounded p-3 text-[12px] focus:outline-none"
              style={{ background: "#1E293B", color: "#fff", border: "1px solid #334155", fontFamily: "'Roboto Mono', monospace", lineHeight: 1.7 }}
            />
            <button className="mt-3 w-full h-10 rounded-md text-xs font-semibold inline-flex items-center justify-center gap-1.5" style={{ background: COLORS.primary, color: "#fff" }}>
              Validate &amp; add 4 SKUs <ChevronRight className="w-3.5 h-3.5"/>
            </button>
          </div>

          <div className="rounded-lg p-4" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
            <div className="text-[10.5px] uppercase tracking-[0.22em]" style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace" }}>Categories</div>
            <div className="mt-2.5 space-y-0.5 text-[12.5px]">
              {["Fasteners", "Washers", "Profiles", "Bearings", "Shafts", "Couplings"].map((c, i) => (
                <button key={c} className="w-full flex items-center justify-between py-1.5 px-2 rounded hover:bg-slate-50">
                  <span>{c}</span>
                  <span style={{ color: COLORS.muted, fontFamily: "'Roboto Mono', monospace", fontSize: 11 }}>{[124,42,38,28,18,15][i]}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="rounded-lg p-4 text-[11.5px]" style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}`, color: COLORS.muted }}>
            <div className="inline-flex items-center gap-1.5 mb-1.5 text-[10.5px] uppercase tracking-[0.22em]" style={{ color: COLORS.text, fontFamily: "'Roboto Mono', monospace" }}>
              <Hash className="w-3 h-3"/>Pro tip
            </div>
            Press <kbd className="px-1.5 py-0.5 rounded" style={{ background: COLORS.hover, fontFamily: "'Roboto Mono', monospace" }}>Tab</kbd> to jump
            between qty fields. Hit <kbd className="px-1.5 py-0.5 rounded" style={{ background: COLORS.hover, fontFamily: "'Roboto Mono', monospace" }}>Enter</kbd> to add the row.
          </div>
        </aside>
      </div>
    </div>
  );
}

function Th({ children, w, right }) {
  return (
    <th style={{ width: w ? `${w}px` : "auto", padding: "10px 12px", textAlign: right ? "right" : "left", color: COLORS.muted, fontSize: 10.5, textTransform: "uppercase", letterSpacing: "0.16em", fontWeight: 600, fontFamily: "'Roboto Mono', monospace" }}>
      {children}
    </th>
  );
}
function Td({ children, right }) {
  return (
    <td style={{ padding: "10px 12px", textAlign: right ? "right" : "left", verticalAlign: "middle" }}>
      {children}
    </td>
  );
}
